import { createContext } from "react";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const initialState: ApplicationInsights = new ApplicationInsights({
	config: {},
});

export const ApplicationInsightsContext = createContext<ApplicationInsights>(initialState);
